import * as React from "react";
const SvgFiRrDiceAlt = (props) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    fill="none"
    viewBox="0 0 24 24"
    {...props}
  >
    <g clipPath="url(#fi-rr-dice-alt_svg__a)">
      <path
        fill="#062147"
        d="M19 24h-5a5.006 5.006 0 0 1-5-5v-5a5.006 5.006 0 0 1 5-5h5a5.006 5.006 0 0 1 5 5v5a5.005 5.005 0 0 1-5 5m-5-13a3 3 0 0 0-3 3v5a3 3 0 0 0 3 3h5a3 3 0 0 0 3-3v-5a3 3 0 0 0-3-3zm0 2a1 1 0 1 0 0 2 1 1 0 0 0 0-2m5 5a1 1 0 1 0 0 2 1 1 0 0 0 0-2M9 7a1 1 0 1 0 0-2 1 1 0 0 0 0 2M7 9a1 1 0 1 0-2 0 1 1 0 0 0 2 0m-.22 6.826a1 1 0 0 0-.154-1.405 3 3 0 0 1-.25-.228l-3.512-3.56a3.005 3.005 0 0 1 .03-4.242l3.56-3.511a2.98 2.98 0 0 1 2.105-.864h.022a2.98 2.98 0 0 1 2.115.893L14.2 6.465q.085.087.163.179A1.003 1.003 0 0 0 15.9 5.356c-.083-.1-.17-.194-.266-.292l-3.514-3.56a5 5 0 0 0-7.07-.048l-3.56 3.51a5.007 5.007 0 0 0-.05 7.072L4.951 15.6q.201.203.423.38a1 1 0 0 0 1.406-.152z"
      />
    </g>
    <defs>
      <clipPath id="fi-rr-dice-alt_svg__a">
        <path fill="#fff" d="M0 0h24v24H0z" />
      </clipPath>
    </defs>
  </svg>
);
export default SvgFiRrDiceAlt;
